import { useAuth } from "@/contexts/AuthContext";
import { User, Calendar, Wifi, Monitor, Clock, LogOut, QrCode } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const userInfo = user?.user_info || {};

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return new Date(dateStr).toLocaleDateString("az-AZ", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">Profil</h1>

      {/* User Card */}
      <div className="bg-zinc-900/50 rounded-xl p-6">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center text-2xl font-bold">
            {userInfo.username?.[0]?.toUpperCase() || "U"}
          </div>
          <div>
            <h2 className="text-xl font-semibold">{userInfo.username || "İstifadəçi"}</h2>
            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium ${
              userInfo.status === "Active" 
                ? "bg-green-600/20 text-green-400" 
                : "bg-red-600/20 text-red-400"
            }`}>
              {userInfo.status === "Active" ? "Aktiv" : userInfo.status || "Status"}
            </span>
          </div>
        </div>

        <div className="grid gap-4">
          <div className="flex items-center gap-3 p-4 bg-zinc-800/50 rounded-lg">
            <Calendar className="w-5 h-5 text-zinc-500" />
            <div>
              <p className="text-sm text-zinc-500">Qeydiyyat tarixi</p>
              <p className="font-medium">{formatDate(userInfo.created_at)}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 bg-zinc-800/50 rounded-lg">
            <Clock className="w-5 h-5 text-zinc-500" />
            <div>
              <p className="text-sm text-zinc-500">Abunəlik bitmə tarixi</p>
              <p className="font-medium">{formatDate(userInfo.expire_at)}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 bg-zinc-800/50 rounded-lg">
            <Monitor className="w-5 h-5 text-zinc-500" />
            <div>
              <p className="text-sm text-zinc-500">Aktiv bağlantılar</p>
              <p className="font-medium">
                {userInfo.active_connections || 0} / {userInfo.max_connections || 1}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 p-4 bg-zinc-800/50 rounded-lg">
            <Wifi className="w-5 h-5 text-zinc-500" />
            <div>
              <p className="text-sm text-zinc-500">Dəstəklənən formatlar</p>
              <p className="font-medium">
                {userInfo.allowed_output_formats?.join(", ").toUpperCase() || "M3U8, TS"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Message */}
      {userInfo.message && (
        <div className="bg-blue-600/10 border border-blue-500/30 rounded-xl p-4">
          <p className="text-blue-400">{userInfo.message}</p>
        </div>
      )}

      {/* QR scan — log in on TV (mobile) */}
      <button
        onClick={() => navigate("/app/qr-scan")}
        data-testid="profile-qr-scan-btn"
        className="md:hidden w-full flex items-center justify-center gap-2 py-3 bg-blue-600/10 hover:bg-blue-600/20 border border-blue-500/30 rounded-xl text-blue-400 font-medium transition-colors"
      >
        <QrCode className="w-5 h-5" />
        QR oxut — TV-də daxil ol
      </button>

      {/* Logout button — visible on mobile (sidebar has it on desktop) */}
      <button
        onClick={handleLogout}
        data-testid="profile-logout-btn"
        className="md:hidden w-full flex items-center justify-center gap-2 py-3 bg-red-600/10 hover:bg-red-600/20 border border-red-500/30 rounded-xl text-red-400 font-medium transition-colors"
      >
        <LogOut className="w-5 h-5" />
        Çıxış
      </button>
    </div>
  );
}
